var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewfoot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 26,
    viewBox: "0 0 102 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "u6nbsbfmqa",
    d: "M0.24 0.003L5.853 0.003 5.853 5.439 0.24 5.439z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bdt876vx6c",
    d: "M0.304 0.003L5.917 0.003 5.917 5.439 0.304 5.439z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iixa325xfe",
    d: "M0.174 0.188L7.276 0.188 7.276 17.849 0.174 17.849z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.007 12.387c2.477 0 3.897-1.28 3.897-3.167v-.064c0-2.111-1.52-3.2-3.996-3.2H5.085v6.431h3.922zM0 3.973c0-1.376 1.123-2.464 2.543-2.464h6.794c2.94 0 5.218.8 6.736 2.272 1.288 1.248 1.981 3.007 1.981 5.119v.064c0 3.52-1.816 5.695-4.623 6.815l3.534 4.16c.495.607.825 1.119.825 1.887 0 1.376-1.188 2.271-2.41 2.271-1.156 0-1.915-.543-2.51-1.28L7.918 16.74H5.085v4.895c0 1.376-1.123 2.463-2.542 2.463C1.123 24.097 0 23.01 0 21.634V3.973zM31.887 13.987c-.297-2.176-1.618-3.647-3.731-3.647-2.08 0-3.434 1.44-3.83 3.647h7.561zM28.651 24.29c-5.316 0-9.245-3.615-9.245-8.862v-.064c0-4.895 3.599-8.926 8.75-8.926 5.91 0 8.52 4.703 8.52 8.254 0 1.408-1.025 2.336-2.346 2.336h-9.938c.495 2.207 2.08 3.36 4.325 3.36 1.387 0 2.543-.417 3.566-1.153.363-.256.694-.384 1.222-.384 1.123 0 1.948.832 1.948 1.92 0 .64-.297 1.12-.66 1.44-1.552 1.28-3.566 2.08-6.142 2.08zM41.889 22.05L37.563 9.956c-.1-.288-.231-.768-.231-1.184 0-1.12.924-2.208 2.41-2.208 1.255 0 2.08.768 2.444 1.888l2.707 8.703 2.774-8.67c.363-1.153 1.288-1.952 2.575-1.952h.298c1.287 0 2.212.8 2.575 1.951l2.807 8.703 2.774-8.767c.33-1.024 1.089-1.856 2.41-1.856 1.387 0 2.345 1.024 2.345 2.24 0 .32-.1.768-.166.992L58.827 22.05c-.528 1.504-1.552 2.175-2.773 2.175h-.165c-1.222 0-2.245-.671-2.708-2.08l-2.807-8.638-2.84 8.639c-.461 1.408-1.485 2.08-2.707 2.08h-.165c-1.222 0-2.245-.672-2.773-2.176",
    transform: "translate(-32 -18) translate(32 18)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -18) translate(32 18) translate(65.747 .295)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bn8f22s8pb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u6nbsbfmqa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.24 2.665C.24 1.015 1.462.003 3.047.003s2.806 1.012 2.806 2.662v.075c0 1.65-1.221 2.7-2.806 2.7S.24 4.39.24 2.74v-.075z",
    mask: "url(#bn8f22s8pb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M69.781 6.445l-.987 5.38-.95-5.388c-1.862.33-2.602 1.663-2.602 3.272l1.39 12.347c0 1.31 1.041 2.015 2.161 2.041 1.121-.026 2.163-.732 2.163-2.041l1.389-12.347c0-1.598-.73-2.923-2.564-3.264",
    transform: "translate(-32 -18) translate(32 18)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -18) translate(32 18) translate(95.241 .295)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t75f99lrbd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bdt876vx6c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.304 2.665C.304 1.015 1.526.003 3.11.003c1.585 0 2.807 1.012 2.807 2.662v.075c0 1.65-1.222 2.7-2.807 2.7-1.584 0-2.806-1.05-2.806-2.7v-.075z",
    mask: "url(#t75f99lrbd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -18) translate(32 18) translate(94.627 6.249)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pbu491lccf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iixa325xfe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.712.196l-.987 5.381-.95-5.389C.914.518.175 1.851.175 3.461l1.388 12.346c0 1.31 1.042 2.016 2.162 2.042 1.121-.026 2.163-.732 2.163-2.042L7.276 3.461c0-1.598-.73-2.923-2.564-3.265",
    mask: "url(#pbu491lccf)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F22245",
    d: "M92.778 15.625l-.001-.275c-.004-1.406-.873-2.371-2.128-2.96L79.08 6.707c-.224-.104-.739-.277-1.156-.28-1.317-.005-2.308 1.122-2.304 2.495l.037 12.936c.004 1.407 1.13 2.544 2.286 2.55.45.002.867-.134 1.188-.27l11.537-5.572c1.282-.577 2.114-1.534 2.11-2.941",
    transform: "translate(-32 -18) translate(32 18)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M86.94 14.766l-5.73-2.564c-.102-.046-.211-.07-.323-.07-.202 0-.4.08-.544.22-.144.14-.224.327-.224.526l.004 2.54-.004 2.539c0 .199.08.386.224.526.144.14.342.22.544.22.112 0 .22-.024.323-.07l5.73-2.564c.268-.12.433-.368.442-.651-.01-.284-.174-.533-.442-.652",
    transform: "translate(-32 -18) translate(32 18)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewfoot);
export default __webpack_public_path__ + "static/media/rewfoot.49bb1d17a92d9f241ecabf773732da37.svg";
export { ForwardRef as ReactComponent };